import React, { useState, useEffect, useRef, Fragment } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useTranslation } from "react-i18next";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function Separator(props) {
    return (
        <div
            style={{
                position: "absolute",
                height: "100%",
                transform: `rotate(${props.turns}turn)`,
                left: "calc(50% - 1px)"
            }}
        >
            <div style={props.style} />
        </div>
    );
}

function RadialSeparators(props) {
    const turns = 1 / props.count;
    return _.range(props.count).map(index => (
        <Separator turns={index * turns} style={props.style} />
    ));
}


export function StatusTracker(props) {
    const { className, value, sections = 5 } = props
    const { t } = useTranslation('common')

    const initial = 0

    const [current, setCurrent] = useState(initial);
    const previous = useRef(initial)
    const [next, setNext] = useState(0);
  

    const splitPerSection = 100 / sections

    const displayValue = (value) => {
        return value * splitPerSection
    }

    useEffect(() => {
        setCurrent(0)
        setNext(0)    
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const nextCurrent = Math.floor(value / splitPerSection)
            setCurrent(nextCurrent)
            setNext(nextCurrent + 1)

            previous.current = value
        })
    }, [value]);
    

    return <div className={classNames('tw-absolute tw-inset-0', className)}> 
        <div className="tw-border-solid tw-border-white/20 tw-border-[16px] tw-rounded-full tw-absolute tw-inset-0 tw-shadow-[0_0_0_0px_rgba(0,0,0,0.2),inset_0_0_0_20px_rgba(0,0,0,0.4)]"></div>
        <div className="tw-animate-[radar_3s_cubic-bezier(0,0,0.2,1)_infinite] tw-rounded-full tw-absolute tw-inset-0 tw-bg-transparent"></div>

        <CircularProgressbar
            className="text-color tw-absolute tw-inset-0"
            value={displayValue(current)}
            strokeWidth="4.5"
            styles={buildStyles({
                // strokeLinecap: "butt",
                pathColor: "#3b82f6",
                trailColor: '#0000'
            })}
        />
        <CircularProgressbar
            className="text-color tw-absolute tw-inset-0 tw-animate-[blink_1s_ease-in-out_infinite]"
            value={displayValue(next)}
            strokeWidth="4.5"
            styles={buildStyles({
                // strokeLinecap: "butt",
                pathColor: "#3b82f6cc",
                trailColor: '#fff0'
            })}
        />
        {/*<RadialSeparators
            count={sections}
            style={{
                background: "#fff2",
                width: "2px",
                // This needs to be equal to props.strokeWidth
                height: `${2}%`
            }}
        />*/}
        <div className="tw-absolute -tw-bottom-20 tw-text-white tw-text-4xl tw-w-full tw-text-center"><span className="tw-font-black">{value}%</span> <span className="tw-font-thin">{t('workspaces.complete')}</span> </div>
    </div>
}